import type { PapelUsuario } from '@pgcustom/shared-types';

export interface PermissoesGarantias {
  ler: boolean;
  atualizar: boolean;
}

/**
 * Espelho, no frontend, do grant real de RBAC do recurso `garantias`
 * (`apps/api/src/modules/garantias/garantias.routes.ts`, seed original
 * da migration `004`): `admin` (curinga `*`) tem tudo; `suporte` só
 * `ler` ("leitura de Pedidos, Garantias...", `PRODUCT.md` 4.7) — não
 * pode configurar dias de cobertura nem solicitar reparo.
 */
export function permissoesGarantias(papel: PapelUsuario): PermissoesGarantias {
  if (papel === 'admin') return { ler: true, atualizar: true };
  if (papel === 'suporte') return { ler: true, atualizar: false };
  return { ler: false, atualizar: false };
}
